import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-foundation',
  templateUrl: './about-foundation.component.html',
  styleUrls: ['./about-foundation.component.scss']
})
export class AboutFoundationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
